<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/union/:id', query: { id: unionId } }">联盟生态</el-breadcrumb-item>
        <el-breadcrumb-item>项目路演列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="roadshow_list_box">
      <div class="glag_left">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>项目路演</span>
            <span class="comment_btn" :class="!topOnOff ? 'act' : ''" @click="sortBtn('time')">时间</span>
            <span class="comment_btn" :class="topOnOff ? 'act' : ''" @click="sortBtn('hot')">热度</span>
            <el-divider></el-divider>
          </p>
        </div>
        <none-view v-if="roadshowList.length === 0" :login="load.login" :loading="load.loading" :data="roadshowList" :text="load.text"></none-view>
        <div class="roadshow_list">
          <div v-for="(item) in roadshowList" :key="item.id" class="roadshow_item">
            <div v-if="item.img !== ''" class="roadshow_item_left" @click="jump(item.list_id)">
              <span v-if="item.type !== 3"></span>
              <img :src="item.img" alt="封面">
            </div>
            <div class="roadshow_item_right" :class="item.img === '' ? 'padding_left_0' : ''">
              <div class="roadshow_item_title" @click="jump(item.list_id)">
                {{item.title}}
              </div>
              <div class="roadshow_item_info">
                <img :src="item.portrait" alt="">
                <span>{{item.user_name}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.add_time}}</span>
              </div>
              <div class="roadshow_item_content">
                {{item.content}}
              </div>
              <div class="roadshow_item_other">
                <el-breadcrumb separator="|">
                  <el-breadcrumb-item class="my_icon_box"><a><i class="my_icon pinglun"></i><span class="my_icon_text">{{item.comment_count}}</span></a></el-breadcrumb-item>
                  <el-breadcrumb-item class="my_icon_box" :class="item.is_collection === 1 ? 'act' : ''"><a><i class="my_icon shoucang"></i><span class="my_icon_text">{{item.post_favorites}}</span></a></el-breadcrumb-item>
                  <el-breadcrumb-item class="my_icon_box r_border"><a><i class="my_icon fenxiang"></i><span class="my_icon_text">{{item.share}}</span></a></el-breadcrumb-item>
                  <el-breadcrumb-item></el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
          </div>
        </div>
        <div v-if="roadshowList.length > 0" class="page_box">
          <page-view :limit="roadshowListPage.limit" :list="roadshowList" :type="roadshowListPage.sort" @pageType="morePage"></page-view>
        </div>
      </div>
      <!-- 推荐项目 -->
      <div class="glag_right">
        <div class="title_top_hr">
          <p>
            <span>推荐</span>
          </p>
          <el-divider></el-divider>
        </div>
        <div class="community_hot_search_box">
          <div v-for="(item, index) in hotRoadshowList" :key="item.id" class="community_hot_search_item">
            <a @click="jump(item.list_id)">
              <i v-if="index === 0" class="first_label">{{index + 1}}</i>
              <i v-if="index === 1" class="two_label">{{index + 1}}</i>
              <i v-if="index === 2" class="three_label">{{index + 1}}</i>
              <i v-if="index > 2" class="glay_label">{{index + 1}}</i>
              {{item.title}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import page from '../Public/page.vue'
import none from '../Public/none.vue'
export default {
  components: {
    pageView: page,
    noneView: none
  },
  data () {
    return {
      unionId: '', // 联盟id
      topOnOff: false, // 栏目切换
      load: {
        login: false, // 是否需要验证登陆
        loading: true, // 加载动画开关
        text: '暂无项目路演' // 列表为空时的提示信息
      },
      roadshowList: [{
        bg_img_path: ''
      }], // 项目路演列表
      roadshowListPage: { // 项目路演列表分页参数
        limit: 10,
        page: 1,
        nav_id: 16, // 板块id
        sort: 2, // 1热度排序 2时间排序
        union_id: ''
      },
      hotRoadshowList: [], // 项目路演推荐列表
      hotRoadshowListPage: { // 项目路演推荐列表分页参数
        limit: 10,
        page: 1,
        nav_id: 16, // 板块id
        union_id: ''
      }
    }
  },
  created () {
    this.unionId = this.$route.query.id
    this.getRoadshowList()
    this.getHotRoadshowList()
  },
  methods: {
    // 获取列表
    getRoadshowList () {
      const vueThat = this
      vueThat.roadshowListPage.union_id = vueThat.unionId
      vueThat.myApi.totalList(vueThat.roadshowListPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.load.loading = false
          if (vueThat.roadshowListPage.page === 1) {
            vueThat.roadshowList = res.data.data
          } else {
            vueThat.roadshowList.push(...res.data.data)
          }
        }
      })
    },
    // 列表排序
    sortBtn (type) {
      const vueThat = this
      vueThat.roadshowList = [] // 重置评论列表
      vueThat.loading = true // 开启加载动画
      vueThat.roadshowListPage.page = 1
      if (type === 'time') {
        vueThat.topOnOff = false
        vueThat.roadshowListPage.sort = 2
        vueThat.getRoadshowList()
      } else {
        vueThat.topOnOff = true
        vueThat.roadshowListPage.sort = 1
        vueThat.getRoadshowList()
      }
    },
    // 获取推荐列表
    getHotRoadshowList () {
      const vueThat = this
      vueThat.hotRoadshowListPage.union_id = vueThat.unionId
      vueThat.myApi.totalRecommendList(vueThat.hotRoadshowListPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.hotRoadshowList = [...vueThat.hotRoadshowList, ...res.data.data]
        }
      })
    },
    // 页面跳转
    jump: function (rid) {
      const routeData = this.$router.resolve({
        path: 'roadshowDetail/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    },
    // 加载更多
    morePage (num, type) {
      const vueThat = this
      vueThat.roadshowListPage.page = num
      vueThat.roadshowListPage.sort = type
      vueThat.getRoadshowList()
    }
  }
}
</script>

<style>
</style>
